import { counted } from '../plural';
import type { Messages } from '../shape';

export const vaults = {
  none: 'Нет хранилища',

  mine: 'Мои',
  sharedWithMe: 'Со мной поделились',
  sharedBadge: 'Общее',
  empty: 'Хранилищ пока нет. Создайте своё или присоединитесь по коду, который вам прислали.',

  noKey: 'Ключа пока нет',
  solo: (notes: number) => `${counted(notes, ['заметка', 'заметки', 'заметок'])} · только вы`,
  withMembers: (notes: number, members: number) =>
    `${counted(notes, ['заметка', 'заметки', 'заметок'])} · ` +
    `${counted(members, ['участник', 'участника', 'участников'])}`,

  labelPrompt: 'Ваша пометка для этого хранилища',
  labelHint:
    'Её видите только вы: она запечатана на ваш собственный ключ, а не на ключ хранилища, ' +
    'поэтому ни другие участники, ни сервер её не прочитают. Убрать её можно пунктом ' +
    '«Убрать пометку».',

  menu: {
    changeIcon: 'Сменить значок',
    addLabel: 'Добавить пометку',
    editLabel: 'Изменить пометку',
    removeLabel: 'Убрать пометку',
    deleteVault: 'Удалить хранилище',
    leaveVault: 'Выйти из хранилища',
  },

  members: 'Участники и доступ',
  keys: 'Ключи и история',
  exportVault: 'Экспорт хранилища…',
  newVault: 'Новое хранилище',
  importVault: 'Импорт хранилища…',
  connectClaude: 'Подключить Claude…',
  join: 'Присоединиться по коду',

  deleteTitle: (name: string) => `Удалить «${name}»?`,
  deleteBody: (notes: number) =>
    'Это уничтожит хранилище и всё, что в нём: ' +
    `${counted(notes, ['заметка', 'заметки', 'заметок'])}. Сервер хранит только шифротекст ` +
    'и удалит его; вернуть хранилище не сможет ни один сохранившийся ключ.',
  deleteBodyShared: (notes: number, members: number) =>
    'Это уничтожит хранилище и всё, что в нём: ' +
    `${counted(notes, ['заметка', 'заметки', 'заметок'])}. Оно исчезнет у всех, кто в нём ` +
    `есть, — ${counted(members, ['участник', 'участника', 'участников'])}. Сервер хранит ` +
    'только шифротекст и удалит его; вернуть хранилище не сможет ни один сохранившийся ключ.',

  leaveTitle: (name: string) => `Выйти из «${name}»?`,
  leaveBody:
    'Доступ к нему пропадёт сразу, а ваши ключи от него удалятся и здесь, и на сервере. ' +
    'Написанное вами останется на месте, но чтобы вернуться, вас должен пригласить снова ' +
    'кто-то из администраторов.',
} satisfies Messages['vaults'];
